import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-walletaccount',
  templateUrl: './walletaccount.component.html',
  styleUrls: ['./walletaccount.component.css']
})
export class WalletaccountComponent implements OnInit {
  @Input('has_account_attached') has_account_attached = false;
  @Input('account_details') account_details :any;
  @Output() addBank = new EventEmitter();
  @Output() removeBank = new EventEmitter();


  constructor() { }

  ngOnInit() {
  }
  addAccount() {
    this.addBank.emit();
  }
  removeAccount() {
    this.removeBank.emit();
  }
}
